// extracted by mini-css-extract-plugin
export default {"sitePage":"SitePage_sitePage__mn8-S","sidebar":"SitePage_sidebar__gCY0w","main":"SitePage_main__S+gY+"};